export var CardType;
(function (CardType) {
    CardType["GENERIC"] = "GENERIC";
    CardType["PROFILE"] = "PROFILE";
    CardType["VALIDATIONS"] = "VALIDATIONS";
    CardType["VEICULOS"] = "VEICULOS";
    CardType["DOCUMENTOS"] = "DOCUMENTOS";
    CardType["ALUNOS"] = "ALUNOS";
})(CardType || (CardType = {}));
export var DocumentosType;
(function (DocumentosType) {
    DocumentosType["CNH"] = "CNH";
    DocumentosType["RG"] = "RG";
})(DocumentosType || (DocumentosType = {}));
